import axiosInstance from './axiosInstance';



export const getPublishersList = async (page, size, token) => {
  try {
    const response = await axiosInstance.get(`publisherstemplatesandattributedata/publishersElasticJSONFullList`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const getPublishersListPage = async (page, size, token) => {
  try {
    const response = await axiosInstance.get(`publishers/ListByPublishers/1`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const getListByAuthoridPublisher = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`publishers/ListByAuthorid/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const uniqueidSearch = async (uniqueid, token) => {
  try {
    const response = await axiosInstance.get(`publishers/uniqueidSearch/${uniqueid}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const fetchPublishers = async (page, pageSize, token) => {
  try {
    const response = await axiosInstance.get(`publishers/PublishersList/1?page=${page}&size=${pageSize}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const publisherDetail = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`publishers/search/publisherdetail/${id}/${status}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};


export const updatePublisher = async (id, status, data, token) => {
  const response = await axiosInstance.post(`publishers/update/${id}/${status}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateStatusPublishers = async (id, status, token) => {
  const response = await axiosInstance.get(`publishers/updateStatus/${id}/${status}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};



export const fetchPublishersSearch = async (token, searchKeyword = "", page = 0, size = 10000) => {
  try {
    const response = await axiosInstance.post(
      `publishers/publisherSearch?page=${page}&size=${size}`,
      {
        searchkeyword: searchKeyword,
        status: 1,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data.data;
  } catch (error) {
    console.error('fetchPublicationSearchn hata oluştu:', error);
    return [];
  }
};

// Son sayının makalelerini getiren servis
export const getArticlesByPublicationIdAndType = async (publicationId, articleType, token, page = 1, newPageSize = 10) => {
  try {
    const safeType = encodeURIComponent(articleType || "Akademik Makale");
    const response = await axiosInstance.post(
      `publicationSearch/search/publicationIdAndPublicationTypeByPublicationList/${publicationId}/${safeType}/1?page=${page}&newpagesize=${newPageSize}`,
      { title: "" },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching articles by publicationId and type:", error);
    throw error;
  }
};

export const getCountryLanguageList = async (token) => {
  try {
    const response = await axiosInstance.get(`systemsettings/countrylanguageList/1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching countries: ", error);
  }
};

export const getPublicationLanguageList = async (token) => {
  try {
    const response = await axiosInstance.get(`systemsettings/publicationlanguageList/1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching languages: ", error);
  }
};